export { default } from "./MegaPanel";
